import Datetime from 'utils/datetime/datetime'

type BidActivityBannerState =
  | { kind: 'sent'; date: ISODateTime }
  | { kind: 'withdrawn'; date: ISODateTime }
  | { kind: 'none' }

// A tied timestamp is not reachable in practice, but must resolve deterministically: it falls to 'sent'.
export function resolveBidActivityBannerState(
  sentDate: ISODateTime | undefined,
  withdrawnDate: ISODateTime | undefined | null
): BidActivityBannerState {
  if (sentDate && withdrawnDate && Datetime.isAfter(withdrawnDate, sentDate)) {
    return { kind: 'withdrawn', date: withdrawnDate }
  }
  if (sentDate) {
    return { kind: 'sent', date: sentDate }
  }
  if (withdrawnDate) {
    return { kind: 'withdrawn', date: withdrawnDate }
  }
  return { kind: 'none' }
}
